import PageDTO from "@/api/commons/PageDTO";

export default class FiltroConsultaFrotaDTO {
  dataInicio?: string;
  dataFim?: string;
  numeroFatura?: number;
  tipoServico?: string;
  idCliente?: number;

  constructor(
    dataInicio?: string,
    dataFim?: string,
    numeroFatura?: number,
    tipoServico?: string,
    idCliente?: number
  ) {
    this.dataInicio = dataInicio;
    this.dataFim = dataFim;
    this.numeroFatura = numeroFatura;
    this.tipoServico = tipoServico;
    this.idCliente = idCliente;
  }
}